import { apiClient } from '../api-client'
import { TimeEntry, CreateTimeEntryRequest, PaginatedResponse } from '@/types'

// Timesheet API
export const timesheetApi = {
  getTimeEntries: (userId?: string, startDate?: string, endDate?: string, page = 1, limit = 20): Promise<PaginatedResponse<TimeEntry>> =>
    apiClient.get('/timesheet', { params: { userId, startDate, endDate, page, limit } }),

  getTimeEntry: (id: string): Promise<TimeEntry> =>
    apiClient.get(`/timesheet/${id}`),

  createTimeEntry: (data: CreateTimeEntryRequest): Promise<TimeEntry> =>
    apiClient.post('/timesheet', data),

  updateTimeEntry: (id: string, data: Partial<CreateTimeEntryRequest>): Promise<TimeEntry> =>
    apiClient.put(`/timesheet/${id}`, data),

  deleteTimeEntry: (id: string): Promise<void> =>
    apiClient.delete(`/timesheet/${id}`),

  approveTimeEntry: (id: string): Promise<TimeEntry> =>
    apiClient.patch(`/timesheet/${id}/approve`),

  rejectTimeEntry: (id: string, reason: string): Promise<TimeEntry> =>
    apiClient.patch(`/timesheet/${id}/reject`, { reason }),

  getWeeklyReport: (userId?: string, weekStart?: string): Promise<TimeEntry[]> =>
    apiClient.get('/timesheet/report/weekly', { params: { userId, weekStart } }),

  exportTimesheet: (userId?: string, startDate?: string, endDate?: string): Promise<Blob> =>
    apiClient.get('/timesheet/export', {
      params: { userId, startDate, endDate },
      responseType: 'blob'
    }),
}